import React, { useMemo } from "react";
import {
  checkLargestTimePassed,
  convertTo12Hours,
  findClosestStartTime,
  findDayFromDayNumber,
  findLargestEndTime,
  findNextSchedule,
  findTimeSlotsForDay,
} from "../../helpers/timeCalculations";
import { FormattedMessage } from "react-intl";

interface IMenuItemSchedulePropsMobile {
  schedule?: any[]; // Optional prop
}

const MenuItemScheduleMobile = ({
  schedule = [],
}: IMenuItemSchedulePropsMobile) => {
  const itemScheduleText = useMemo(() => {
    let today = new Date().getDay() + 1;
    const todaySchedule = schedule.find((item) =>
      item.days.days.includes(today.toString())
    );
    const largestEndTime = findLargestEndTime(today, schedule);
    const hasLargestEndTimePassed = checkLargestTimePassed(
      largestEndTime || ""
    );
    const currentTime = new Date();
    const currentTimeHours = currentTime.getHours();
    const currentTimeMinutes = currentTime.getMinutes();
    const currentTimeString = `${currentTimeHours
      .toString()
      .padStart(2, "0")}:${currentTimeMinutes.toString().padStart(2, "0")}`;

    if (todaySchedule && !hasLargestEndTimePassed) {
      // Find the appropriate time slot based on current time
      const timeSlots = todaySchedule.time_slots;

      // Check if currently within any time slot
      const currentSlot = timeSlots.find(
        (slot: any) =>
          currentTimeString >= slot.start_time &&
          currentTimeString <= slot.end_time
      );

      if (currentSlot) {
        return (
          <FormattedMessage
            id="global.item_slot_available_now"
            defaultMessage="This item is available from {startTime} to {endTime}"
            values={{
              startTime: convertTo12Hours(currentSlot.start_time),
              endTime: convertTo12Hours(currentSlot.end_time),
            }}
          />
        );
      } else {
        // Find next upcoming time slot
        const upcomingSlot = timeSlots.find(
          (slot: any) => currentTimeString < slot.start_time
        );
        if (upcomingSlot) {
          return (
            <FormattedMessage
              id="global.item_slot_available_after"
              defaultMessage="This item is not available at the moment, but will be back again at {startTime}"
              values={{
                startTime: convertTo12Hours(upcomingSlot.start_time),
              }}
            />
          );
        }
      }
    } else {
      today = today + 1;
      const nextSchedule = findNextSchedule(today, schedule);
      if (nextSchedule) {
        const dayName = findDayFromDayNumber(nextSchedule);
        const timeSlots = findTimeSlotsForDay(nextSchedule, schedule);
        const currentTime = new Date();
        const currentTimeHours = currentTime.getHours();
        const currentTimeMinutes = currentTime.getMinutes();
        const currentTimeString = `${currentTimeHours}:${currentTimeMinutes}`;
        const closestTimeSchedule = findClosestStartTime(
          currentTimeString,
          timeSlots
        );
        return (
          <FormattedMessage
            id="global.item_slot_available_another_day"
            defaultMessage="This item is not available for the day, but will be back again by {dayName}"
            values={{
              dayName: dayName
            }}
          />
        );
      }
    }
    return null;
  }, [schedule]);

  return (
    <div style={{ fontSize: "10px" }} className="my-1">
      <p>{itemScheduleText}</p>
    </div>
  );
};

export default MenuItemScheduleMobile;
